<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text>
        <v-alert class="bg-info" light dense prominent>
          <v-list class="bg-info" dense>
            <v-list-item class="px-0">
              <v-list-item-avatar>
                <v-avatar color="white">
                  <v-icon>
                    mdi-bank-plus
                  </v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <h3>Informasi Penambahan Sekolah Penggerak</h3>
                <p class="mb-0">Silakan pilih data sekolah peserta PSP beserta Kepala Sekolah yang ingin ditambahkan</p>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-alert>
        <v-row class="mb-2">
          <v-col cols="12" md="6">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-title>
                  <span class="px-0 body-2 info--text" style="height: 24px;">
                    Pilih Instansi Sekolah Penggerak
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle class="link black--text body-2">
                  <v-btn dark color="orange" class="text-capitalize" @click="onOpenSelect('sekolah')">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Pilih Instansi
                  </v-btn>
                </v-list-item-subtitle>
                <div class="mt-2" v-if="$isObject(selected['sekolah'])">
                  <v-list>
                    <v-list-item>
                      <v-list-item-avatar class="mr-3" size="48">
                        <v-avatar color="secondary" size="65">
                          <v-icon dark>mdi-bank</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="secondary--text font-weight-medium subtitle-1" style="line-height: 1">
                          {{ $getDeepObj(selected['sekolah'], 'nama') }}
                        </div>
                        <div class="body-2 mt-1">
                          <span class="font-weight-medium">NPSN: {{ $getDeepObj(selected['sekolah'], 'npsn') }}</span>
                          <br />
                          <span class="font-weight-medium">
                            Status:
                            {{ +$getDeepObj(selected['sekolah'], 'is_negeri') === 1 ? 'Negeri' : 'Swasta' }}
                          </span>
                          <br />
                          <span class="font-weight-medium">
                            Alamat:
                            {{ $getDeepObj(selected['sekolah'], 'alamat') || '-' }}
                          </span>
                          <br />
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="6">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-title>
                  <span class="px-0 body-2 info--text" style="height: 24px;">
                    Pilih Kepala Sekolah
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle class="link black--text body-2">
                  <v-btn dark color="orange" class="text-capitalize" @click="onOpenSelect('kasek')">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Pilih Kepala Sekolah
                  </v-btn>
                </v-list-item-subtitle>

                <div class="mt-2" v-if="$isObject(selected['kasek'])">
                  <v-list>
                    <v-list-item>
                      <v-list-item-avatar class="mr-3" size="48">
                        <v-avatar color="secondary" size="65">
                          <v-icon dark>mdi-account</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="secondary--text font-weight-medium subtitle-1" style="line-height: 1">
                          {{ $getDeepObj(selected['kasek'], 'nama') }}
                        </div>
                        <div class="body-2 mt-1">
                          <template>
                            <span class="font-weight-medium">No. UKG: </span>
                            {{ $getDeepObj(selected['kasek'], 'no_ukg') }}
                            <br />
                          </template>
                          <template>
                            <span class="font-weight-medium">
                              <v-icon
                                v-if="$getDeepObj(selected['kasek'], 'no_hp')"
                                class="mr-1"
                                color="success"
                                small
                                dark
                                left
                              >
                                mdi-whatsapp
                              </v-icon>
                              {{ $getDeepObj(selected['kasek'], 'no_hp') || '-' }}
                            </span>
                            <br />
                          </template>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <base-form-generator :schema="schema" v-model="form" />
      </v-card-text>
    </v-card>
    <popup-selector :simple-paging="true" ref="popup" :title="popup['title']" :fetch="popup['fetch']">
      <template slot-scope="{ row }">
        <td>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-row no-gutters>
                <v-col cols="12" md="9">
                  <template v-if="popup['tipe'] === 'sekolah'">
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3" size="48">
                        <v-avatar color="secondary" size="65">
                          <v-icon dark>mdi-bank</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="black--text font-weight-medium subtitle-1" style="line-height: 1">
                          {{ $getDeepObj(row, 'nama') || '-' }}
                        </div>
                        <div class="body-2 mt-1">
                          <template v-if="row.sekolah_id">
                            <span class="font-weight-medium">NPSN: </span>
                            {{ $getDeepObj(row, 'npsn') || '-' }}
                            <br />
                          </template>
                          <template v-if="row.sekolah_id">
                            <span class="font-weight-medium">Status: </span>
                            {{ +$getDeepObj(row, 'is_negeri') === 1 ? 'Negeri' : 'Swasta' }}
                            <br />
                          </template>
                          <template v-if="row.sekolah_id">
                            <span class="font-weight-medium">Alamat: </span>
                            {{ $getDeepObj(row, 'alamat') || '-' }}
                            <br />
                          </template>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-else>
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3" size="48">
                        <v-avatar color="secondary" size="65">
                          <v-icon dark>mdi-account</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="black--text font-weight-medium subtitle-1" style="line-height: 1">
                          {{ $getDeepObj(row, 'nama') || '-' }}
                        </div>
                        <div class="body-2 mt-1">
                          <span class="font-weight-medium">No. UKG: </span>
                          {{ $getDeepObj(row, 'no_ukg') || '-' }}
                          <br />
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <span class="grey--text" style="font-size: 13px">
                        Status
                      </span>
                      <div v-if="popup['tipe'] === 'sekolah'">
                        <v-chip small class="ma-2" :color="+row.is_aktif === 1 ? 'green' : 'red'" text-color="white">
                          {{ +row.is_aktif === 1 ? 'Aktif' : 'Tidak Aktif' }}
                        </v-chip>
                      </div>
                      <div v-else>
                        <v-chip small class="ma-2" color="blue" text-color="white">
                          Bisa Dipilih
                        </v-chip>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
            <v-list-item-action-text>
              <v-radio-group v-model="form.select">
                <v-radio
                  :value="popup['tipe'] === 'sekolah' ? row.sekolah_id : row.ptk_id"
                  @click="onSelect(row)"
                ></v-radio>
              </v-radio-group>
            </v-list-item-action-text>
          </v-list-item>
        </td>
      </template>
    </popup-selector>
  </div>
</template>

<script>
import PopupSelector from '@components/popup/Selector';
import { mapActions } from 'vuex';
import BaseFormGenerator from '@components/base/BaseFormGenerator';
export default {
  name: 'FormPeserta',
  components: { BaseFormGenerator, PopupSelector },
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      popup: {},
      form: {},
      selected: {},
    };
  },
  computed: {
    schema() {
      return [
        {
          type: 'VTextarea',
          name: 'alasan',
          label: 'Alasan Ditambahkan',
          labelColor: 'info',
          placeholder: 'Alasan Ditambahkan',
          rows: 1,
          grid: { cols: 12 },
          outlined: true,
          required: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VTextField',
          name: 'sk_nomor',
          label: 'Nomor SK Kepala Sekolah',
          hint: 'wajib diisi',
          required: false,
          labelColor: 'info',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VDatePicker',
          name: 'sk_tanggal',
          label: 'Tanggal SK Kepala Sekolah',
          labelColor: 'info',
          usePrependInnerIcon: 'mdi-calendar-month',
          hint: 'wajib diisi',
          required: false,
          outlined: true,
          singleLine: true,
          hideDetails: true,
          dense: true,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          type: 'VTextField',
          name: 'sk_url',
          label: 'Tautan Berkas SK Kepala Sekolah',
          hint: 'wajib diisi',
          required: false,
          labelColor: 'info',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VSelect',
          name: 'k_kp_kategori_psp',
          label: 'Kriteria / Model Pendampingan',
          labelColor: 'info',
          placeholder: 'Pilih kriteria / model pendampingan',
          hint: 'wajib diisi',
          items: this.$mapForMaster(this.masters && this.masters.kp_kategori_psp),
          required: true,
          outlined: true,
          singleLine: true,
          readonly: this.readOnly,
          dense: true,
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          type: 'VSelect',
          name: 'gelombang',
          label: 'Gelombang',
          labelColor: 'info',
          hint: 'wajib diisi',
          items: this.masters && this.masters.gelombang,
          required: true,
          outlined: true,
          singleLine: true,
          readonly: this.readOnly,
          dense: true,
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          type: 'VTextarea',
          name: 'catatan',
          label: 'Catatan Tambahan',
          labelColor: 'info',
          placeholder: 'Catatan Tambahan',
          rows: 1,
          grid: { cols: 12 },
          outlined: true,
          required: true,
          dense: true,
          singleLine: true,
        },
      ];
    },
  },
  methods: {
    ...mapActions('pelaksana', ['fetchActions']),

    reset() {
      this.popup = {};
      this.form = {};
      this.selected = {};
    },

    getValue() {
      return this.form;
    },

    onOpenSelect(tipe) {
      this.$set(this.popup, 'title', tipe === 'sekolah' ? 'Pilih Sekolah Penggerak' : 'Pilih Kepala Sekolah');
      this.$set(this.popup, 'fetch', tipe === 'sekolah' ? this.getListSekolah : this.getListKasek);
      this.$set(this.popup, 'tipe', tipe);

      if (this.$isObject(this.selected[tipe]))
        this.$set(this.form, 'select', this.selected[tipe][tipe === 'sekolah' ? 'sekolah_id' : 'ptk_id']);

      this.$refs.popup.open();
      this.$nextTick(() => {
        this.$refs.popup.onReload();
      });
    },

    getListSekolah({ params }) {
      return this.fetchActions({ action: 'sekolah', params });
    },

    getListKasek({ params }) {
      return this.fetchActions({ action: 'ptk', params });
    },

    onSelect(data) {
      const tipe = this.popup['tipe'];
      this.$set(this.selected, tipe, data);
      this.$set(
        this.form,
        tipe === 'sekolah' ? 'sekolah_id' : 'ptk_id',
        data[tipe === 'sekolah' ? 'sekolah_id' : 'ptk_id']
      );

      // init kasek jika memilik ptk_tugases
      if (tipe === 'sekolah' && data && data.ptk_tugases && data.ptk_tugases.length) {
        this.$set(this.selected, 'kasek', this.$getDeepObj(data.ptk_tugases[0], 'ptk'));
        this.$set(this.form, 'ptk_id', this.$getDeepObj(data.ptk_tugases[0], 'ptk.ptk_id'));
      }

      this.$refs.popup.close();
    },
  },
};
</script>

<style scoped></style>
